/**
 * 站点全局信息（公司信息集中在此维护）
 */
export default {
  companyName: '浩连科技',
  companyNameEn: 'HOLINK TECH',
  slogan: '让每一个想法，都能被交付',
  sloganEn: 'Deliver every idea',
  description:
    '浩连科技是一家专注软件定制开发的科技服务公司，深耕小程序、App、网站与系统开发，为企业和创业者提供从需求分析、UI 设计到研发上线的一站式数字化解决方案。',
  phone: '17745876591',
  mobile: '177-4587-6591',
  email: '275876954@qq.com',
  address: '甘肃省酒泉市肃州区',
  workingHours: '周一至周天 09:00 - 20:00',

  stats: [
    { value: 120, suffix: '+', label: '成功交付项目' },
    { value: 80, suffix: '+', label: '合作企业客户' },
    { value: 20, suffix: '+', label: '资深研发团队' },
    { value: 10, suffix: '年', label: '行业深耕经验' }
  ],
  nav: [
    { name: '首页', path: '/' },
    { name: '关于我们', path: '/about' },
    { name: '产品服务', path: '/services' },
    { name: '案例展示', path: '/cases' },
    { name: '联系我们', path: '/contact' }
  ]
}
